<template>
  <div class="mit-admin-key-page mit-page">
    <MitKeyEditor class="doNotPrint" :show="showKeyEditor" :keyModel="editorKeyModel" :spacesModel="spaces" v-on:save="keyEditorSave" v-on:cancel="keyEditorCancel"/>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">

            <v-card-title class="doNotPrint" >ADMIN - Key Management</v-card-title>
            <v-card-subtitle class="caption doNotPrint">CSAIL Key Management</v-card-subtitle>
            <v-divider></v-divider>
            <v-toolbar color="primary" dense class="doNotPrint hideOnMobile">
              <v-btn color="white" :text="menuIndex != 0" @click="menuChange(0)">Keys</v-btn>
              <v-btn disabled color="white" :text="menuIndex != 1" @click="menuChange(1)">Keys Import</v-btn>
            </v-toolbar>
            <v-card-text>
            <div v-if="menuIndex == 0">
              <div class="hideOnMobile doNotPrint">
                <h2 >ADMIN Keys</h2>
                <p>Create and edit keys</p>
              </div>
                  <MitKeysList></MitKeysList>
              </div>
              <div v-if="menuIndex == 1">
                <MitImportKeysList />
              </div>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitPageLoadingService from '../../services/MitPageLoadingService.js';
  import MitKeysService from '../../services/MitKeysService.js';
  import MitSpacesService from '../../services/MitSpacesService.js';
  import MitKeyEditor from '../../components/MitKeyEditor.vue';

  import MitKeysList from '../../components/MitKeysList.vue';

  export default {
    name: 'MitAdinEquipmentPage',
    components: {
      MitKeysList,
      MitKeyEditor
    },
    data: function() {
      return {
        menuIndex:0,
        showKeyEditor:false,
        keysData:{
          items:[]
        },
        editorKeyModel:null,
        spaces:[]
      }
    },
    created(){
    },
    mounted() {
      this.keysRefresh();
      this.spacesRefresh();
    },
    methods: {
      menuChange(index) {
        this.menuIndex = index;
        switch(index){
          case 0:
            this.keysRefresh();
            break;
          case 1:
            //this.import();
            break;
        }
      },
      keysRefresh() {
        MitKeysService.requestGetKeys()
          .then((data) => {
            this.keysData.items = data;
          })
          .catch((error) => {
            console.log('An error occurred trying to get keys list', error);
          });
      },
      spacesRefresh() {
        MitSpacesService.getCurrentSpaceList()
          .then((data) => {
            this.spaces = data;
          })
          .catch((error) => {
            console.log('An error occurred trying to get keys list', error);
          });
      },
      keyImportCreate(){

      },
      keyImportEdit(){

      },
      keyImportDelete(){

      },
      keyCreate() {
        this.editorKeyModel = MitKeysService.getNewKey();
        this.showKeyEditor = true;
        console.log('create');
      },
      keyEdit(item) {
        this.editorKeyModel = item;
        this.showKeyEditor = true;
        console.log('edit',item);
      },
      keyDelete(item) {
        console.log('delete',item);
        MitKeysService.requestDeleteKey(item.name)
          .then((data) => {
            return this.keysRefresh();
          })
          .catch((error) => {
            console.log('An error occurred trying to delete key: '+item.name, error);
          });

      },
      keyEditorSave(item) {
        this.showKeyEditor = false;
        this.editorKeyModel = null;
        MitKeysService.requestSaveKey(item)
          .then((data) => {
            return this.keysRefresh();
          })
          .catch((error) => {
            console.log('An error occurred trying to get keys list', error);
          });
      },
      keyEditorCancel(item) {
        this.showKeyEditor = false;
        this.editorKeyModel = null;
        console.log('cancel');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }

  @media only screen and (min-width: 599px){
    .showOnMobile {
      display:none
    }
  }
  @media print {
    main .v-main   {
      width: 100%;
      padding: 0 !important;
      // margin:-40px 0 0 -250px !important;
  }
  .v-main__wrap {
    max-width: none;
    margin: 0 -250px;
  }
}
